<template>
<div class="container">
    <p>注意：所有KP均已运营商核验判定，准确率高达<span class="special-word">95%</span>以上；</p>
    <p>分值：</p>
    <p>A：源自于各查查的企业工商年报（打过去都是有效号码，提高工作效率）&#x1F60E;</p>
    <p>B：源自于全网公开信息爬取以及工商渠道，对于A渠道号码质量更高，骚扰率更低（销冠资源，用的好你就是下一个销冠）&#x1F60F;</p>
    <p>C：帮寻客内部渠道，强力推荐使用，同行都没有就你有（适合沉浸行业多年的老司机更大范围开发新客户），你不成交谁成交&#x1F92D;</p>
</div>
</template>
<script>
    export default {
        data() {
            return {

            };
        },
        methods:{

        }
    };
</script>
<style lang="scss">

.container {
  font-size: 17px;
  font-weight: bold;
  margin-left: 10px;
}

.special-word {
  color: #ff5722;
}
    .logos-container {
  margin: 20px 0 40px 0;
  text-align: center;
  svg {
    display: inline-block;
  }
}

.devextreme-logo {
  width: 200px;
  height: 34px;
  margin-bottom: 17px;
}

.vue-logo {
  width: 180px;
  height: 62px;
}

.plus {
  margin: 20px 10px;
  width: 22px;
  height: 22px;
}

.screen-x-small .logos-container {
  svg {
    width: 100%;
    display: block;
    &.plus {
      margin: 0;
    }
  }
}
</style>
